import { Helmet } from "react-helmet";

function SEOHelmet() {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Alpaca Safety Software | All-in-One Safety & Compliance App</title>
      <meta
        name="description"
        content="Streamline your safety and compliance workflows with our mobile-ready app. Track training, inspections, equipment, and incident reports in real time—on any device."
      />
      <link rel="canonical" href="https://www.alpacasys.com/" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.alpacasys.com/" />
      <meta
        property="og:title"
        content="Alpaca Safety Software | All-in-One Safety & Compliance App"
      />
      <meta
        property="og:description"
        content="Streamline safety and compliance with real-time dashboards. Manage training, inspections, assets, and incidents from one platform."
      />
      <meta
        property="og:image"
        content="https://www.images.alpacasys.com/images/social-preview.jpg"
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://www.alpacasys.com/" />
      <meta
        name="twitter:title"
        content="Alpaca Safety Software | All-in-One Safety & Compliance App"
      />
      <meta
        name="twitter:description"
        content="Streamline safety and compliance with real-time dashboards. Works seamlessly on desktop, tablet, and mobile."
      />
      <meta
        name="twitter:image"
        content="https://www.images.alpacasys.com/images/social-preview.jpg"
      />

      {/* Mobile and SEO Best Practices */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index, follow" />
      <link rel="icon" href="https://www.images.alpacasys.com/favicon.ico" />
      <meta name="theme-color" content="#ffffff" />
      <html lang="en" />
    </Helmet>
  );
}

export default SEOHelmet;
